<template>
  <div class="inline-error flex flex-col items-center gap-2" role="alert">
    <span class="material-icons text-error" aria-hidden="true">{{ icon }}</span>
    <p class="text-sm m-0">
      <slot>{{ message }}</slot>
    </p>
  </div>
</template>

<script setup>
/**
 * @component InlineError
 * @description Messaggio di errore inline dentro un contenitore (card, box, lista), al posto del contenuto
 * che non è stato possibile caricare. Non è un overlay: per feedback modale usare StatusAlert.
 * Classi del chiamante (es. state-center / state-empty) arrivano sul root per fallthrough.
 *
 * @prop {String} message - Testo dell'errore (già tradotto). Ignorato se si usa lo slot default.
 * @prop {String} icon    - Icona Material Icons mostrata sopra il testo. Default 'error_outline'.
 *
 * @slot default - Contenuto del messaggio in alternativa a `message`.
 */
defineProps({
  message: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "error_outline",
  },
});
</script>
